const RECENT_FORMS_KEY = 'kzq_recent_forms';
const RECENT_TICKETS_KEY = 'kzq_recent_tickets';
const MAX_RECENT = 5;

export function useRecentlyVisited() {

    const addRecentForm = (form) => {
        try {
            let recent = JSON.parse(localStorage.getItem(RECENT_FORMS_KEY) || '[]');
            recent = recent.filter(f => f.formId !== form.formId);
            recent.unshift({ ...form, timestamp: Date.now() });
            localStorage.setItem(RECENT_FORMS_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)));
        } catch(e) {}
    };

    const addRecentTicket = (ticket) => {
        try {
            let recent = JSON.parse(localStorage.getItem(RECENT_TICKETS_KEY) || '[]');
            recent = recent.filter(t => t.ticketId !== ticket.ticketId);
            recent.unshift({ ...ticket, timestamp: Date.now() });
            localStorage.setItem(RECENT_TICKETS_KEY, JSON.stringify(recent.slice(0, MAX_RECENT)));
        } catch(e) {}
    };

    const getRecentForms = () => {
        try {
            return JSON.parse(localStorage.getItem(RECENT_FORMS_KEY) || '[]');
        } catch(e) { return []; }
    };

    const getRecentTickets = () => {
        try {
            return JSON.parse(localStorage.getItem(RECENT_TICKETS_KEY) || '[]');
        } catch(e) { return []; }
    };

    return { addRecentForm, addRecentTicket, getRecentForms, getRecentTickets };
}
